<template>
  <span
    class="clickable"
    @click="copy"
  >
    <slot>
      <q-btn
        unelevated
        flat
        round
        :color="buttonColor"
        size="sm"
      >
        <transition
          name="fade"
          mode="out-in"
        >
          <q-icon
            :key="buttonIcon"
            :name="buttonIcon"
          />
        </transition>
      </q-btn>
    </slot>
  </span>
</template>
<script>
import { Notify, copyToClipboard } from "quasar";
import frQuasar from "quasar/lang/fr";
import enQuasar from "quasar/lang/en-US";

export default {
  name: 'ClipboardCopy',
  props: {
    content: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: false,
    }
  },
  data() {
    return {
      buttonIcon: 'las la-copy',
      buttonColor: 'primary',
      isAnimating: false
    }
  },
  methods: {
    copy: async function() {
      if (this.isAnimating) return;

      this.isAnimating = true;
      try {
        copyToClipboard(this.content)
          .then(() => {
            Notify.create({
              message: this.message || this.i18n('copied'),
              type: "positive",
              icon: "las la-clipboard-check",
              timeout: 1000,
            });
          })
          .catch(() => {
            Notify.create({
              message: this.i18n("copied_error"),
              type: "negative",
              icon: "info",
              timeout: 1000,
            });
          });
        this.buttonIcon = 'las la-check';
        this.buttonColor = 'positive';
      } catch (error) {
        console.error('Failed to copy:', error);
        this.buttonIcon = 'fas fa-times-circle';
        this.buttonColor = 'negative';
      } finally {
        setTimeout(() => {
          this.buttonIcon = 'las la-copy';
          this.buttonColor = 'primary';
          this.isAnimating = false;
        }, 3000);
      }
    },
    i18n: function(key) {
      switch (this.$q.lang.isoName) {
      case enQuasar.isoName:
        return {
          copied: "Copied to clipboard",
          copied_error: "Error copying to clipboard",
        }[key];
      case frQuasar.isoName:
        return {
          copied: "Copié dans le presse-papier",
          copied_error: "Erreur lors de la copie dans le presse-papier",
        }[key];
      }
    },
  },
}
</script>
<style scoped>
.fade-enter-active {
    transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}

.fade-leave-active {
    transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
    transform: scale(0.8);
}

.fade-enter-to,
.fade-leave-from {
    opacity: 1;
    transform: scale(1);
}
</style>
